import React from 'react'

const TitleBox = React.memo(({ title, children }) => {

    return (
        <div className='my-5 flex justify-between items-center'>
            <h4 className='ext-sm uppercase font-medium'>{title}</h4>
            <div className='flex items-center'>
                {children}
            </div>
        </div>
    )
});

export default TitleBox